import { Component, computed, MaybeRefOrGetter, toValue } from 'vue'
import { RouteLocationAsRelative } from 'vue-router'
import { NavItem, RouteName } from '../types/navigation.types'

export type ResolvedNavItem =
  | { kind: 'link'; id: string; label: string; icon?: Component;
      to: RouteLocationAsRelative; activeFor?: readonly RouteName[]; exact?: boolean }
  | { kind: 'external'; id: string; label: string; icon?: Component; href: string }
  | { kind: 'group'; id: string; label: string; icon?: Component; children: ResolvedNavItem[] }

function resolve<Ctx>(items: readonly NavItem<Ctx>[], ctx: Ctx): ResolvedNavItem[] {
  return items.flatMap((item): ResolvedNavItem[] => {
    if (item.visible && !item.visible(ctx)) return []
    const { ...rest } = item
    switch (rest.kind) {
      case 'link':
        return [{ ...rest, to: rest.to(ctx) }]
      case 'external':
        return [{ ...rest, href: typeof rest.href === 'function' ? rest.href(ctx) : rest.href }]
      case 'group': {
        const children = resolve(rest.children, ctx)
        return children.length ? [{ ...rest, children }] : []
      }
    }
  })
}

export function useResolvedNav<Ctx>(
  items: MaybeRefOrGetter<readonly NavItem<Ctx>[]>,
  ctx: MaybeRefOrGetter<Ctx>,
) {
  return computed(() => resolve(toValue(items), toValue(ctx)))
}